// extracted by mini-css-extract-plugin
export default {"crossSiteLabel":"f2-z"};